import React, { useEffect, useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useGetProductQuery } from '../../Store/api/apiSlice';
import { getRelatedProducts } from '../../Store/products/productsSlice'
import { useDispatch, useSelector } from 'react-redux';
import Product from './Product';
import Products from './Products';
import { assetUrl } from '../../utils/imageUrl';
import { addViewedProduct } from '../../utils/viewedProducts';
import Preloader from '../Preloader/Preloader';

const SingleProduct = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const { list, related } = useSelector(({ products }) => products);

  const { data, isLoading, isFetching, isSuccess } = useGetProductQuery({ id });

  useEffect(() => {
    if(!isLoading && !isFetching && !isSuccess) {
      navigate('/');
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [isLoading, isFetching, isSuccess])

  useEffect(() => {
    if (!data?.category?.id || !list.length) return;
    dispatch(getRelatedProducts(data.category.id));
  }, [data, dispatch, list.length]);

  useEffect(() => {
    if (data?.id) {
      addViewedProduct(data.id);
    }
  }, [data?.id]);

  const manualRelated = useMemo(
    () => (data?.relatedProducts || []).filter((item) => Number(item.id) !== Number(data?.id)),
    [data?.relatedProducts, data?.id]
  );

  const autoRelated = useMemo(
    () => related.filter((item) => Number(item.id) !== Number(data?.id)),
    [related, data?.id]
  );

  const relatedProducts = manualRelated.length > 0 ? manualRelated : autoRelated;

  // SEO мета-теги
  useEffect(() => {
    if (!data) return;

    const title = data.metaTitle || data.title;
    document.title = title;

    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', data.metaDescription || data.shortDescription || data.title);

    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (data.metaKeywords) {
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.setAttribute('name', 'keywords');
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.setAttribute('content', data.metaKeywords);
    } else if (metaKeywords) {
      metaKeywords.remove();
    }

    const setOGMeta = (property, content) => {
      let ogMeta = document.querySelector(`meta[property="${property}"]`);
      if (!ogMeta) {
        ogMeta = document.createElement('meta');
        ogMeta.setAttribute('property', property);
        document.head.appendChild(ogMeta);
      }
      ogMeta.setAttribute('content', content);
    };

    setOGMeta('og:title', title);
    setOGMeta('og:description', data.metaDescription || data.shortDescription || data.title);
    if (data.images && data.images.length > 0) {
      setOGMeta('og:image', assetUrl(data.images[0]));
    }
    setOGMeta('og:type', 'product');

    return () => {
      document.title = 'Інтернет-магазин';
    };
  }, [data]);

  return !data ? (
    <Preloader message="Завантаження товару…" />
  ) : (
    <>
      <Product {...data} />
      {relatedProducts.length > 0 && (
        <Products
          products={relatedProducts}
          amount={manualRelated.length > 0 ? relatedProducts.length : 4}
          title="Супутні товари"
        />
      )}
    </>
  );
};

export default SingleProduct;
